export namespace IndividualExplanationParams {
    /** 
     * Translated from enum com.dataiku.dip.analysis.ml.prediction.flow.IndividualExplanationParams$ExplanationsMethod
     * Via: com.dataiku.dip.analysis.ml.interactivemodel.InteractiveModelParams$ExplanationsParams
     */
    export enum ExplanationsMethod {
        ICE = "ICE",
        SHAPLEY = "SHAPLEY",
    }
}